import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { SharedUtils } from "../../../../../../shared/shared.utils";
import { SessionStateService } from "../../../../../../core/services/session-state.service";
import { DevicesService } from "../../../../../devices/devices.service";
import { EnergyService } from "../../../../../energy/energy.service";
import { LoadingModule, ANIMATION_TYPES } from "ngx-loading";

declare var TweenMax: any;
@Component({
  selector: "app-self-consumption-flow",
  templateUrl: "./self-consumption-flow.component.html",
  styleUrls: ["./self-consumption-flow.component.scss"],
})
export class SelfConsumptionFlowComponent implements OnInit, OnChanges {
  @Input()
  gridInjection;
  @Input()
  selfConsumption;
  @Input()
  gridConsumption;
  @Input()
  hasStorage: boolean;
  @Input()
  consumptionSmartMeterIsOnline: boolean;
  @Input()
  atLeastOneProductionModuleIsOnline: boolean;

  SharedUtils = SharedUtils;

  totalProduction = null;
  totalConsumption = null;
  storagePercentage: number;

  consumptionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    backdropBackgroundColour: "rgba(0, 0, 0, 0)",
  };

  productionLoadingAnimationConfig = {
    animationType: ANIMATION_TYPES.circleSwish,
    primaryColour: "#287aab",
    secondaryColour: "#287aab",
    tertiaryColour: "#287aab",
    backdropBackgroundColour: "rgba(0, 0, 0, 0)",
  };

  constructor(
    private devicesService: DevicesService,
    private energyService: EnergyService,
    public sessionStateService: SessionStateService
  ) {}

  ngOnInit() {
    if (this.hasStorage) {
      /** Get Battery */
      this.devicesService
        .getEnergyStorage(this.sessionStateService.getHouse().houseId)
        .subscribe((storage) => {
          if (storage[0]) {
            this.energyService
              .getBatteryStatus(Number(storage[0].getModuleLocalId()))
              .subscribe((val) => {
                this.storagePercentage = val;
              });
          }
        });
    }
  }

  ngOnChanges() {
    // Needed since in JS null + null = 0 -.-'
    if (this.selfConsumption !== null || this.gridConsumption !== null) {
      this.totalConsumption = Number(
        this.selfConsumption + this.gridConsumption
      );
    }

    if (this.selfConsumption !== null || this.gridInjection !== null) {
      this.totalProduction = Number(this.selfConsumption + this.gridInjection);
    }
  }

  getBatteryIcon(percentage: number) {
    if (percentage > 75) {
      return "assets/img/icons/ic_battery_full.svg";
    } else if (percentage <= 75 && percentage > 50) {
      return "assets/img/icons/ic_battery_75.svg";
    } else if (percentage <= 50 && percentage > 25) {
      return "assets/img/icons/ic_battery_50.svg";
    } else if (percentage <= 25 && percentage > 15) {
      return "assets/img/icons/ic_battery_25.svg";
    } else if (percentage < 15 && percentage > 0) {
      return "assets/img/icons/icon-low-battery.svg";
    } else if (percentage === 0) {
      return "assets/img/icons/ic_battery_empty.svg";
    }
  }

  getHouseGridIcon() {
    if (this.selfConsumption > 0 && this.gridConsumption > 0) {
      return "/assets/img/icons/flow-house-grid-solar.svg";
    } else if (this.selfConsumption > 0 && this.gridConsumption === 0) {
      return "/assets/img/icons/flow-house-solar.svg";
    } else if (this.selfConsumption === 0 && this.gridConsumption > 0) {
      return "/assets/img/icons/flow-house-grid.svg";
    } else {
      return "/assets/img/icons/flow-house-none.svg";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/home/home-tab/home-flows-view/flows/self-consumption-flow/self-consumption-flow.component.ts